import { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import { supabase } from '../utils/supabase';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function VisitCard() {
  const [loading, setLoading] = useState(false);
  const [added, setAdded] = useState(false);

  const handleAddToWallet = async () => {
    try {
      setLoading(true);
      const cleanBase = BASE.replace(/\/+$/, '');
      const res = await fetch(`${cleanBase}/api/visit-card`);
      if (!res.ok) throw new Error('Error al descargar');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'wafiyo-card.pkpass';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      setAdded(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="visit-page">
      <div className="visit-container">
        {/* Logo */}
        <div className="visit-logo-row">
          <Logo size={32} />
          <span className="visit-brand">Wafiyo</span>
        </div>

        {/* Hero */}
        <h1 className="visit-hero">
          Tarjetas de fidelidad <span className="text-gradient">digitales</span>
        </h1>
        <p className="visit-subtitle">
          Crea tarjetas de sellos para Apple Wallet y Google Wallet. 
          Tus clientes las guardan en su móvil y acumulan visitas automáticamente.
        </p>

        {/* Card mockup */}
        <div className="visit-card-display">
          <div className="visit-pass-mockup">
            <div className="vpm-header">
              <div className="vpm-logo">W</div>
              <span>Wafiyo</span>
            </div>
            <div className="vpm-strip">
              <span className="vpm-url">wafiyo.com</span>
              <span className="vpm-sub">Tarjetas de fidelidad digital</span>
            </div>
            <div className="vpm-fields">
              <div>
                <div className="vpm-label">WEB</div>
                <div className="vpm-value">wafiyo.com</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div className="vpm-label">SOPORTE</div>
                <div className="vpm-value" style={{ fontSize: 11 }}>support@wafiyo.com</div>
              </div>
            </div>
            <div className="vpm-aux">
              <div>
                <div className="vpm-label">OFERTA</div>
                <div className="vpm-value">30 días gratis</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div className="vpm-label">PLATAFORMA</div>
                <div className="vpm-value">Apple & Google</div>
              </div>
            </div>
            <div className="vpm-qr">
              <div className="vpm-qr-box">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#0a1a12" strokeWidth="2">
                  <rect x="3" y="3" width="7" height="7" />
                  <rect x="14" y="3" width="7" height="7" />
                  <rect x="3" y="14" width="7" height="7" />
                  <rect x="14" y="14" width="3" height="3" />
                  <rect x="18" y="18" width="3" height="3" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* CTA buttons */}
        <div className="visit-actions">
          <button
            onClick={handleAddToWallet}
            disabled={loading}
            className="visit-wallet-btn"
          >
            {loading ? (
              <span>Descargando...</span>
            ) : added ? (
              <span>✓ Descargado — Ábrelo para añadir</span>
            ) : (
              <>
                <svg viewBox="0 0 384 512" width="20" height="20" fill="currentColor">
                  <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
                </svg>
                <span>Añadir a Apple Wallet</span>
              </>
            )}
          </button>

          <Link to="/register" className="visit-register-btn">
            Crear mi cuenta gratis →
          </Link>
        </div>

        {/* Features */}
        <div className="visit-features">
          <div className="visit-feature">
            <span className="visit-feature-icon">📱</span>
            <div>
              <strong>Apple & Google Wallet</strong>
              <p>Tus clientes llevan la tarjeta siempre encima</p>
            </div>
          </div>
          <div className="visit-feature">
            <span className="visit-feature-icon">⚡</span>
            <div>
              <strong>Sellos automáticos</strong>
              <p>Escanea el QR y se acumula la visita al instante</p>
            </div>
          </div>
          <div className="visit-feature">
            <span className="visit-feature-icon">🔔</span>
            <div>
              <strong>Notificaciones push</strong>
              <p>Recuerda a tus clientes que vuelvan</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="visit-footer">
          <p>support@wafiyo.com · <a href="https://wafiyo.com" style={{ color: '#1A7A4A' }}>wafiyo.com</a></p>
        </div>
      </div>

      <style>{`
        .visit-page {
          min-height: 100vh;
          background: #fafafa;
          display: flex;
          justify-content: center;
          padding: 40px 20px;
        }
        .visit-container {
          max-width: 440px;
          width: 100%;
          text-align: center;
        }
        .visit-logo-row {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-bottom: 32px;
        }
        .visit-brand {
          font-size: 24px;
          font-weight: 800;
          color: #0A0A0A;
          letter-spacing: -0.5px;
        }
        .visit-hero {
          font-size: 28px;
          font-weight: 800;
          color: #0A0A0A;
          line-height: 1.2;
          margin-bottom: 12px;
        }
        .visit-subtitle {
          font-size: 15px;
          color: #555;
          line-height: 1.6;
          margin-bottom: 32px;
        }

        /* Card display */
        .visit-card-display {
          display: flex;
          justify-content: center;
          margin-bottom: 32px;
        }
        .visit-pass-mockup {
          width: 260px;
          background: #0a1a12;
          border-radius: 18px;
          overflow: hidden;
          color: #fff;
          box-shadow: 0 12px 40px rgba(0,0,0,0.25), 0 0 0 1px rgba(26, 122, 74, 0.2);
        }
        .vpm-header {
          padding: 14px 16px;
          display: flex;
          align-items: center;
          gap: 10px;
          font-weight: 700;
          font-size: 16px;
        }
        .vpm-logo {
          width: 28px;
          height: 28px;
          background: #1A7A4A;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
          font-size: 15px;
        }
        .vpm-strip {
          background: linear-gradient(135deg, #0f2e1d, #1A7A4A, #0a1a12);
          padding: 24px 16px;
          text-align: center;
        }
        .vpm-url {
          display: block;
          font-size: 18px;
          font-weight: 700;
          letter-spacing: 0.5px;
        }
        .vpm-sub {
          display: block;
          font-size: 12px;
          color: rgba(255,255,255,0.5);
          margin-top: 4px;
        }
        .vpm-fields {
          padding: 12px 16px;
          display: flex;
          justify-content: space-between;
        }
        .vpm-aux {
          padding: 8px 16px 12px;
          display: flex;
          justify-content: space-between;
          border-top: 1px solid rgba(255,255,255,0.06);
        }
        .vpm-label {
          font-size: 9px;
          color: #7ec8a0;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 2px;
        }
        .vpm-value {
          font-size: 13px;
          font-weight: 600;
        }
        .vpm-qr {
          padding: 12px 16px 16px;
          display: flex;
          justify-content: center;
        }
        .vpm-qr-box {
          width: 52px;
          height: 52px;
          background: #fff;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* Actions */
        .visit-actions {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-bottom: 40px;
        }
        .visit-wallet-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          background: #0a0a0a;
          color: #fff;
          padding: 14px 28px;
          border-radius: 14px;
          border: none;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 16px rgba(0,0,0,0.2);
          font-family: inherit;
          width: 100%;
        }
        .visit-wallet-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 24px rgba(0,0,0,0.3);
        }
        .visit-wallet-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        .visit-register-btn {
          display: block;
          padding: 14px;
          border-radius: 14px;
          border: 1px solid rgba(26, 122, 74, 0.2);
          background: rgba(26, 122, 74, 0.06);
          color: #1A7A4A;
          font-size: 15px;
          font-weight: 600;
          text-decoration: none;
          transition: all 0.2s;
        }
        .visit-register-btn:hover {
          background: rgba(26, 122, 74, 0.12);
          border-color: rgba(26, 122, 74, 0.3);
        }

        /* Features */
        .visit-features {
          display: flex;
          flex-direction: column;
          gap: 16px;
          text-align: left;
          margin-bottom: 40px;
        }
        .visit-feature {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          padding: 14px 16px;
          background: #fff;
          border-radius: 14px;
          border: 1px solid rgba(0,0,0,0.06);
        }
        .visit-feature-icon {
          font-size: 24px;
          flex-shrink: 0;
          margin-top: 2px;
        }
        .visit-feature strong {
          font-size: 14px;
          color: #0A0A0A;
          display: block;
          margin-bottom: 2px;
        }
        .visit-feature p {
          font-size: 13px;
          color: #777;
          margin: 0;
          line-height: 1.4;
        }

        /* Footer */
        .visit-footer {
          font-size: 13px;
          color: #999;
        }
        .visit-footer a {
          text-decoration: none;
        }
      `}</style>
    </div>
  );
}
